import request from '@/assets/util/request'   //ajax请求

export const resourcesList = (data)=> {
    return request({
        url: `/agent/api/list/home`,
        method: 'post',
        data: data,
        params:data
    })
}



export const salesList = (data)=> {
    return request({
        url: `/agent/api/sell`,
        method: 'post',
        data: data,
        params:data
    })
}


export const resourcesDetail = (data)=> {
    return request({
        url: `/agent/api/detail/home/${data.id}`,
        method: 'get',
        params:data,
        data: data,
    })
}



